
    import {renderToDom} from './src/app.tsx';
    renderToDom(document.getElementById('strictly-silvr-cart'));
  